import axios from "axios";

export const usersService = {
	toggleIntoxication,
	getSinglePosUser,
	getUserTransactions,
	getUserPackagePlans,
	getUsersInCabin,

	unmarkIntoxication,
};

function getUserTransactions(id, data) {
	return axios.get(`/user-profiles/${id}/transactions`, {
		params: data
	})
	.then((res) => {
		return res
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getUserPackagePlans(profileId) {
	return axios.get(`/user-profiles/${profileId}/package-plans`)
	.then((res) => {
		return res
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function toggleIntoxication(data, user_id) {
	return axios.post(`/user-profiles/${user_id}/intoxication-log`, data)
	.then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getSinglePosUser(data) {
	return axios.get(`/user-profiles/${data}`)
	.then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

async function getUsersInCabin(cabinId) {
	return await axios.get('/user-profiles', {
		params: {
			cabin: cabinId,
		}
	});
}


async function unmarkIntoxication(userId) {
	return await axios.post(`/user-profiles/${userId}/intoxication-log/unmark`);
}
